var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 43C33.374 43 43 33.374 43 21.5S33.374 0 21.5 0 0 9.626 0 21.5 9.626 43 21.5 43Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 43.09c11.874 0 21.5-9.626 21.5-21.5S33.374.09 21.5.09 0 9.716 0 21.59c0 11.875 9.626 21.5 21.5 21.5Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.868.094C9.996-.11.206 9.35.003 21.224c-.115 6.731 2.885 12.782 7.663 16.805a5.719 5.719 0 0 1 1.02-.725l6.415-3.5a2.62 2.62 0 0 0 1.365-2.3v-2.629s-1.883-2.252-2.6-5.381a2.158 2.158 0 0 1-.996-1.81v-2.878c0-.632.282-1.198.72-1.594v-4.159s-.855-6.472 7.91-6.472 7.91 6.472 7.91 6.472v4.16c.439.395.72.96.72 1.593v2.878c0 .967-.65 1.78-1.53 2.052-.492 1.526-1.2 2.981-2.136 4.304-.236.333-.457.616-.65.835v2.696c0 .992.56 1.9 1.448 2.343l6.87 3.434c.412.206.785.467 1.128.757 4.633-3.864 7.626-9.641 7.737-16.146C43.2 10.086 33.742.296 21.868.094Z",
    fill: "#7498e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.102 33.803-6.415 3.5a5.764 5.764 0 0 0-1.03.732 21.401 21.401 0 0 0 13.844 5.057 21.416 21.416 0 0 0 13.764-4.985 5.69 5.69 0 0 0-1.13-.758l-6.87-3.434a2.62 2.62 0 0 1-1.449-2.344v-2.695c.193-.22.414-.502.65-.836a15.807 15.807 0 0 0 2.136-4.303 2.158 2.158 0 0 0 1.53-2.053v-2.877c0-.633-.282-1.198-.72-1.594v-4.16s.855-6.471-7.91-6.471-7.91 6.472-7.91 6.472v4.159a2.145 2.145 0 0 0-.72 1.594v2.877c0 .758.399 1.425.995 1.81.72 3.13 2.601 5.382 2.601 5.382v2.629c0 .957-.524 1.84-1.366 2.298Z",
    fill: "#EFF7F5"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h43v43H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.b937ba37b3bae8806ddf969f3f57a719.svg";
export { ForwardRef as ReactComponent };